//JavaScript Document
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import modules from "@/store/modules";

import * as TYPE from "./mutation-types";

export default new Vuex.Store({
	modules
});
